import { IDate } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { clipText } from '@new/domains/operations/utils/text'

import { RunFlags } from '../../../StayTimeline.items'
import { GuestInboxTimelineEvent } from '../../../StayTimeline.types'
import { getEventWhen } from '../../../StayTimeline.utils'
import { ChannelTag } from '../../ChannelTag'
import { TimelineAvatar } from '../../TimelineAvatar'
import { MessageAttachments, stripAttachmentPlaceholders } from './MessageAttachments'
import { MessageBubble } from './MessageBubble'
import * as Bubble from './MessageBubble/MessageBubble.styles'

interface GuestMessageProps {
  event: GuestInboxTimelineEvent
  flags: RunFlags
  guestName?: string | null
  checkIn?: IDate | null
  checkout?: IDate | null
}

export const GuestMessage = ({ event, flags, guestName, checkIn, checkout }: GuestMessageProps) => {
  const name = event.who || guestName || 'AvantStay'
  const body = stripAttachmentPlaceholders(event)

  return (
    <MessageBubble
      isInbound
      flags={flags}
      avatar={<TimelineAvatar name={name} variant="guest" />}
      header={
        <>
          <Bubble.Name>{name}</Bubble.Name>
          <ChannelTag channel={event.channel} medium={event.medium} />
        </>
      }
    >
      {body ? (
        <Bubble.Bubble $variant="in" $isRunStart={flags.isFirst}>
          {clipText(body, 900)}
        </Bubble.Bubble>
      ) : null}

      <MessageAttachments isInbound attachments={event.attachments} />

      {flags.isLast ? <Bubble.When>{getEventWhen(event.at, checkIn, checkout)}</Bubble.When> : null}
    </MessageBubble>
  )
}
